import { configureStore } from '@reduxjs/toolkit';
import modalSheetSlice from './slices/modal-sheet.slice.js';
import toastSlice from './slices/toast.slice.js';

const dodoStore = configureStore({
  reducer: {
    modalSheet: modalSheetSlice.reducer,
    toast: toastSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoreState: true,
        ignoreActions: true,
      },
    }),
});

export default dodoStore;
